import React from 'react';

import { Table, Input } from 'antd';
import { generateColumns } from './columns'
import Description from './description';

const { Search } = Input;
import _ from 'lodash';

const filterData = (data, search) => {
  return data.filter(obj => {
    const msg = typeof (obj.message) === 'object' ? JSON.stringify(obj.message) : obj.message
    return msg.includes(search)
  })
}

const ContactTable = ({ contacts }) => {
  const [search, setSearch] = React.useState('')

  const tags = _.compact(_.uniq(_.map(contacts, 'tag')))
  const columns = generateColumns({ tags })

  const data = contacts.map(contact => {
    return ({ ...contact, key: contact.id })
  })
  const filteredData = filterData(data, search)

  const onSearch = (value, _event) => {
    setSearch(value)
  }

  return (<>
    <Search placeholder="Search Messages" enterButton
      onSearch={onSearch}
    />
    <Table columns={columns}
      dataSource={filteredData}
      pagination={{ position: ['topRight', 'bottomRight'], defaultPageSize: 50 }}
      expandable={{
        expandedRowRender: record => <Description info={record.info}/>,
        rowExpandable: record => !_.isEmpty(record.info),
      }}
    />
  </>)
};

export default ContactTable;
